import React from 'react';
import { Grid } from '@material-ui/core';

import CustomerList from './CustomerList';
import Transactions from './Transactions';
import { Customer as CustomerModel } from './customer.model'

// import customers from './data';
import { getAllCustomerRefRealTime } from './customer.service';

class Customers extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            customers: [0]
        }
    }

    async componentDidMount() {
        // const customers = await getAllCustomerModel();
        getAllCustomerRefRealTime((customers: CustomerModel[]) => {
            customers.sort((a: CustomerModel, b: CustomerModel) => {
                let textA = a.name.toUpperCase()
                let textB = b.name.toUpperCase()
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            this.setState({
                customers
            });
        });
    }

    render() {
        return (
            <Grid container>
    
                <Grid item container xl={3} lg={3} md={3} component="div">
                    <CustomerList customers={this.state.customers} {...this.props}/>
                </Grid>
    
                <Grid item container xl={9} lg={9} md={9} component="div">
                    <Transactions {...this.props} customerList={this.state.customers}/>
                </Grid>
            </Grid>
        );
    }
};

export default Customers;